import { useEffect, useState } from "react";

import useTranslation from "../hooks/useTranslation";

import REQUESTS from "../api/requests";

import TEXT from "../configs/text";

import Message from "./Message";

import styles from "./styles/Input.module.scss";
import classNames from "classnames";

export default function ValidateMacAddress({
  setMacIsValid,
  value = "",
  setValue,
  setDevice = () => { },
}) {
  const translation = useTranslation();

  const [message, setMessage] = useState({
    text: "",
    type: true,
  });


  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleText = (text) => {
    if (translation?.general?.[text]) {
      return translation?.general?.[text];
    }

    return TEXT?.general?.[text];
  };

  const validateMacAddress = () => {

    if (value?.length === 0) {
      return;
    }

    function callback(data) {
      if (setDevice) {
        setDevice(data);
      }

      setMacIsValid(true);
      setMessage({
        text: handleText("mac_input_valid_message"),
        type: true,
      });

      let macs = JSON.parse(localStorage.getItem("mac-history") || "[]");
      if (!macs.includes(value)) {
        macs.push(value);
        localStorage.setItem("mac-history", JSON.stringify(macs));
      }
    }

    function errorCallback(error) {
      setMacIsValid(false);
      setMessage({
        text: handleText("mac_input_not_valid_message"),
        type: false,
      });
    }

    REQUESTS.VALIDATE_MAC(value, callback, errorCallback);
  };

  const generateMacFormat = (e) => {
    var mac = e.target.value.replace(/[^0-9a-z]/gi, "");
    var result = "";

    for (var i = 0; i < mac.length; i++) {
      if (i % 2 === 0 && i !== 0) {
        result += ":";
      }
      result += mac[i];
    }
    setValue(result.substring(0, 17));

    const history = JSON.parse(localStorage.getItem("mac-history") || "[]");
    const filtered = history.filter((m) => m.startsWith(mac));
    setSuggestions(filtered);
    setShowSuggestions(filtered.length > 0);
  };

  const handleSuggestionClick = (mac) => {
    setValue(mac);
    setShowSuggestions(false);
  };

  const handleRemoveSuggestion = (mac) => {
    const history = JSON.parse(localStorage.getItem("mac-history") || "[]");
    const updatedHistory = history.filter((m) => m !== mac);
    localStorage.setItem("mac-history", JSON.stringify(updatedHistory));
    setSuggestions(updatedHistory);
    setShowSuggestions(updatedHistory.length > 0);
  };

  useEffect(() => {

    if (value?.length === 17) {
      validateMacAddress();
    } else {
      setMacIsValid(false);
      setMessage({
        text: "",
        type: false,
      });
    }

  }, [value]);

  useEffect(() => {
    const history = JSON.parse(localStorage.getItem("mac-history") || "[]");
    setSuggestions(history);
  }, []);

  return (<div className={styles["input-wrapper"]}>
    <div className={styles["input-container"]}>
      <input
        autoComplete="on"
        value={value}
        onChange={generateMacFormat}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
        onFocus={() => {
          const macs = JSON.parse(localStorage.getItem("mac-history") || "[]");
          setSuggestions(macs);
          setShowSuggestions(macs.length > 0);
        }}
        placeholder={handleText("mac_input_placeholder")}
        name="mac"
      />
      <Message message={message} />
    </div>
    {(
      <ul className={classNames(styles["suggestion-box"], { [styles["show"]]: showSuggestions })}>
        {suggestions.map((mac, i) => (
          <li className={styles["suggestion-item"]} key={i} onClick={() => handleSuggestionClick(mac)}>
            <span className={styles["suggestion-text"]}>{mac}</span> <span className={styles["remove-suggestion"]} onClick={(e) => {
              e.stopPropagation();
              handleRemoveSuggestion(mac);
            }}>x</span>
          </li>
        ))}
      </ul>
    )}
  </div>
  );
}